import request from '@/utils/request'
import { method } from '@/utils/constant'

const { POST, GET } = method

export default {
  // 编辑基本信息
  async getMessageList(params) {
    return request({
      method: POST,
      url: '/member/message/web/list',
      params: {
        ...params,
      },
    })
  },

  // 未读数量
  async getUnreadCount(params) {
    return request({
      method: POST,
      url: '/member/message/web/noReadCount',
    })
  },
  // un-ack
  async getNotAckedCount(params) {
    return request({
      method: POST,
      url: '/member/message/web/getNotAckedCount',
    })
  },
  // total
  async getAllCount(params) {
    return request({
      method: POST,
      url: '/member/message/web/getAllCount',
    })
  },

  // 消息详情
  async getMessageDetail(params) {
    return request({
      method: POST,
      url: `/member/message/web/detail/${params.id}`,
    })
  },

  // 消息回执
  async handleReceipt(params) {
    return request({
      method: POST,
      url: '/member/message/web/ack',
      params: params,
    })
  },

  // 反馈列表
  async getFeedbackData(params) {
    return request({
      method: POST,
      url: '/member/message/web/feedback/list',
      params,
    })
  },

  // 新增反馈
  async addFeedback(params) {
    return request({
      method: POST,
      url: '/member/message/web/feedback/save',
      params,
    })
  },

  // /3A/list
  //             /3A/get
  //             /one/list
  //             /one/get
  //             /group/list
  //             /group/get
  //             /message/web/feedback/getMemberUserOranizationTree
  //             /message/web/getAllCount
  //             /message/web/getNotAckedCount
  //             /message/web/noReadCount
  //             /getUserCard
  //             /member/member/select/{type}
  //             getMemberUserChange()
  //             saveMemberUserChange
  //             /admin/background/memberChange/{id}?operation=1
  async getFeedbackOrgTree() {
    return request({
      method: POST,
      url: '/member/message/web/feedback/getMemberUserOranizationTree',
    })
  },
}
